<template>
  <div class="nav-theme-dark nav-layout-left">
    <a-layout style="min-height: 100vh">

      <a-layout-sider
        theme="dark"
        :trigger="null"
        collapsible
        v-model="collapsed"
        width="256px"
      >
        <router-link class="logo" to="/">
          <img src="../assets/logo.png" height="32px" alt="logo" />
          <h1>设备管理平台</h1>
        </router-link>

        <SideMenu theme="dark" :collapsed="collapsed"></SideMenu>

      </a-layout-sider>

      <a-layout :class="['layout-right', collapsed ? 'side-fold' : '']">
        <div class="layout-right-container">
          <a-layout-header :class="collapsed ? 'side-fold' : ''">
            <a-icon
              class="tigger"
              :type="collapsed ? 'menu-unfold' : 'menu-fold'"
              @click="handlerTaggleCollapsed"
            ></a-icon>
            <Header></Header>
          </a-layout-header>

          <a-layout-content>
            <MultiTab></MultiTab>
            <PageHead></PageHead>
            <div class="content-warp">
              <RouteView></RouteView>
            </div>
          </a-layout-content>

          <!-- <a-layout-footer style="text-align: center">
            <Footer></Footer>
          </a-layout-footer>   -->
        </div>
      </a-layout>
    </a-layout>
  </div>
</template>

<script>
import RouteView from './RouteView'
import Header from './Header'
import Footer from './Footer'
import SideMenu from './SideMenu'
import PageHead from '@/components/PageHead'
import { mapState } from 'vuex'

export default {
  name: 'BasicLayout',
  components: {
    RouteView,
    Header,
    // Footer,
    SideMenu,
    PageHead
  },
  data() {
    return {
      collapsed: false
    }
  },
  computed: {
    ...mapState(['userInfo'])
  },
  mounted() {
  },
  methods: {
    handlerTaggleCollapsed() {
      this.collapsed = !this.collapsed
      // 触发 window.resize
      const event = document.createEvent('HTMLEvents')
      event.initEvent('resize', true, true)
      event.eventType = 'message'
      window.dispatchEvent(event)
    }
  }
}
</script>

<style scoped>
.tigger {
  padding: 0 20px;
  line-height: 64px;
  font-size: 20px;
}
.tigger:hover {
  background: #eee;
}
.logo {
  display: block;
  height: 64px;
  line-height: 64px;
  text-align: center;
  overflow: hidden;
}
.logo h1 {
  vertical-align: middle;
  display: inline-block;
  color: #fff;
  font-size: 20px;
  margin: 0 0 0 12px;
}
.nav-theme-dark >>> .logo {
  color: #fff;
}

.ant-layout-sider {
  position: fixed;
  height: 100%;
  z-index: 106;
  min-height: 100vh;
  box-shadow: 2px 0 6px rgba(0, 21, 41, 0.35);
}

.ant-layout.layout-right {
  padding-left: 256px;
  min-height: 100vh;
  transition: width 0.2s;

  /* min-width: 1366px; */
  overflow-x: auto !important;
  /* overflow-x: unset !important; */
}
.ant-layout.layout-right.side-fold {
  padding-left: 80px;
  min-height: 100vh;
}

.layout-right-container {
  height: 100%;
  min-width: 1110px;
  overflow-x: auto;
}

.ant-layout-header {
  background: #fff;
  padding: 0;
  border-bottom: 1px solid #e8e8e8;
  width: 100%;
}

.ant-layout-content {
  height: calc(100% - 64px);
  position: relative;
}
</style>
